import script from "./DetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsView.vue?vue&type=script&setup=true&lang=js"

import "./DetailsView.vue?vue&type=style&index=0&id=bff546a8&scoped=true&lang=css"
import "./DetailsView.vue?vue&type=style&index=1&id=bff546a8&lang=less&scoped=true"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bff546a8"]])

export default __exports__